class MultiPurposeDrawer {
  constructor() {
    this.drawer = document.getElementById('MultiDrawer');
    this.title = document.getElementById('MultiDrawerTitle');
    this.content = document.getElementById('MultiDrawerContent');
    this.overlay = this.drawer.querySelector('.drawer__overlay');
    this.closeBtn = this.drawer.querySelector('.drawer__close');

    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => e.key === 'Escape' && this.close());
  }

  open(contentKey, customTitle = '') {
    const source = document.querySelector(`[data-drawer-content="${contentKey}"]`);
    if (!source) return console.error('Drawer content not found:', contentKey);

    // Clone the content so it doesn’t get removed from the hidden area
    this.content.innerHTML = '';
    this.content.appendChild(source.cloneNode(true));

    // Update title
    this.title.textContent = customTitle || source.dataset.title || contentKey.charAt(0).toUpperCase() + contentKey.slice(1).replace('-', ' ');

    this.drawer.classList.add('open');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.drawer.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(() => this.content.innerHTML = '', 350); // clear after animation
  }
}

// Initialize once
document.addEventListener('DOMContentLoaded', () => {
  window.multiDrawer = new MultiPurposeDrawer();

  // Example buttons – add as many as you want anywhere in your theme
  document.querySelectorAll('[data-open-drawer]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const key = btn.dataset.openDrawer;
      const title = btn.dataset.drawerTitle || '';
      window.multiDrawer.open(key, title);
    });
  });
});